import { lazy } from 'react';
import * as routePath from '../route-path';
import * as routeName from '../route-name';
import { AccountTierIcon, CampaignIcon } from 'components/Atoms/Icon';
import { USER_ROLES } from 'constants/common';

const PartnerProgram = lazy(() =>
  import('modules/partner-program/PartnerProgram')
);
const ProcessDividendPayouts = lazy(() =>
  import('modules/partner-program/ProcessDividendPayouts')
);

export const partnerProgramRoutes = [
  {
    path: routePath.PARTNER_PROGRAM,
    component: PartnerProgram,
    exact: true,
    name: routeName.PARTNER_PROGRAM,
    showMenu: true,
    icon: AccountTierIcon,
    roles: [USER_ROLES.ADMIN],
    breadcrumbs: [{ name: routeName.PARTNER_PROGRAM }],
  },
  {
    path: routePath.PROCESS_DIVIDEND_PAYOUTS,
    component: ProcessDividendPayouts,
    exact: true,
    name: routeName.PROCESS_DIVIDEND_PAYOUTS,
    showMenu: false,
    icon: AccountTierIcon,
  },
];
